/**
 * `wpp::toggle`
 *
 * Two shapes of state, deliberately: `wired` entangles with a Livewire property
 * so the server is the source of truth, and otherwise the toggle owns its own
 * value and nothing goes over the wire until something else submits it.
 *
 * @param {boolean} enabled
 */
export default (enabled = false) => ({
    enabled,

    toggle() {
        this.enabled = ! this.enabled;
    },
});
